import styled from "styled-components";

import {MENU_WIDTH} from "components/theme";
import { DRAWER_MINI_WIDTH, DRAWER_WIDTH } from "layout/menuConfig";

// Legacy wrapper, still used by the employee portal menu.
export const WrapMenu = styled.div`
    .os-drawer > div{
        z-index:1099;
        width:${MENU_WIDTH};
        padding-top:64px;
        transition: transform 0.3s ease-in;
        height:100vh;
    }
    .menu-open .os-drawer > div{
        transform: translate(0px,0px);
    }
    .menu-close .os-drawer > div{
        transform: translate(-${MENU_WIDTH},0px);
    }

  .MuiListItemIcon-root{
    width:56px;
    height: 27px;
     img{
       height: 20px;
       margin-top: 3px;
     }
  }

`;

export const Icon = styled.img`
    width: 30px;
    height: 30px;
`;

// Admin sidebar: a permanent drawer whose width switches between extended and icons only.
export const AdminDrawer = styled.div`
    .os-admin-drawer .MuiDrawer-paper {
        z-index: 1099;
        width: ${DRAWER_WIDTH}px;
        padding-top: 64px;
        height: 100vh;
        overflow-x: hidden;
        transition: width 0.2s ease-in;
    }
    .os-admin-drawer.mini .MuiDrawer-paper {
        width: ${DRAWER_MINI_WIDTH}px;
    }
`;
